import Icon from '../../../../components/UI/Icon'

import { tradingAssetsTableHeadings, tradingAssetsTableRows } from '../../../../constants'

const TradingAssetsTable = () => {
  const canLoadMore = true

  const handleLoadMore = () => {}

  const tradingMarketTableHeadingsContent = tradingAssetsTableHeadings.map(
    (tradingAssetsTableHeading) => {
      return (
        <th
          key={tradingAssetsTableHeading}
          className="text-[#758696] font-normal p-[15px] text-sm w-[16%]"
        >
          {tradingAssetsTableHeading}
        </th>
      )
    }
  )

  const tradingMarketTableRowsContent = tradingAssetsTableRows.map((tradingAssetsTableRow) => {
    return (
      <tr
        key={tradingAssetsTableRow.id}
        className="border-t-[#f0f3fa] border-t-[1px] hover:bg-[#f6f8f9]"
      >
        <td className="text-sm p-[15px] w-[16%] text-[#4a4a4a] font-normal">
          {tradingAssetsTableRow.balance}
        </td>

        <td className="text-sm p-[15px] w-[16%] text-[#4a4a4a] font-normal">
          <div className="flex items-center">
            <img
              src={tradingAssetsTableRow.coinIcon}
              alt={tradingAssetsTableRow.coin}
              className="w-[18px] h-[18px] mr-[5px]"
            />

            <span>&nbsp;{tradingAssetsTableRow.coin}</span>
          </div>
        </td>

        <td className="text-sm p-[15px] w-[16%] text-[#4a4a4a] font-normal">
          {tradingAssetsTableRow.lastPrice}
        </td>

        <td
          className={`text-sm p-[15px] w-[16%] font-normal ${tradingAssetsTableRow.change.startsWith('+') ? 'text-green-trading' : 'text-red-trading'}`}
        >
          {tradingAssetsTableRow.change}
        </td>

        <td className="text-sm p-[15px] w-[16%] text-[#4a4a4a] font-normal">
          {tradingAssetsTableRow.high}
        </td>

        <td className="text-sm p-[15px] w-[16%] text-[#4a4a4a] font-normal">
          {tradingAssetsTableRow.low}
        </td>

        <td className="text-sm p-[15px] w-[16%] text-[#4a4a4a] font-normal">
          {tradingAssetsTableRow.volume}
        </td>
      </tr>
    )
  })

  return (
    <div className="w-full flex flex-col pb-[50px]">
      <table className="bg-white w-full text-[#212529] border-collapse">
        <thead>
          <tr>{tradingMarketTableHeadingsContent}</tr>
        </thead>
        <tbody>{tradingMarketTableRowsContent}</tbody>
      </table>

      {canLoadMore && (
        <button
          className="flex items-center mx-auto mt-[50px] px-[30px] py-[11px] border-[1px] border-white rounded-[4px]"
          onClick={handleLoadMore}
        >
          <span className="text-base font-semibold text-white">Load More&nbsp;</span>

          <Icon name="arrow-down-solid" color="#fff" className="w-[10.69px] h-[20px] ml-[10px]" />
        </button>
      )}
    </div>
  )
}

export default TradingAssetsTable
